import { defineMessages } from 'react-intl'


// The IAB TCF v2 Vendor Device Storage & Operational Disclosures spec
// defines only the `sdks[].name` / `sdks[].use` JSON schema and is silent on
// display labels for end-user-facing UIs. See:
//
//   https://github.com/InteractiveAdvertisingBureau/GDPR-Transparency-and-Consent-Framework/blob/master/TCFv2/Vendor%20Device%20Storage%20%26%20Operational%20Disclosures.md
//
// "Description" is used instead of "Use" (awkward as an English column
// header) or "Purpose" (would collide semantically with the TCF "Purposes"
// section already shown above in the same vendor detail panel).
//
export default defineMessages({
  description: {
    defaultMessage: 'Description',
    id: 'sdk-disclosure-table.description',
  },
  name: {
    defaultMessage: 'Name',
    id: 'sdk-disclosure-table.name',
  },
})
